import moment from 'moment';
import { FOOD_BENEFIT_STATES } from  'common/domain/constants';
import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';

const MIN_DAYS = 0;

class CardRequestDaysController {

  constructor(EventEmitter, $scope, floatingActionButtonsService) {
    'ngInject';
    this.inEditMode = false;
    this.wasFirstEdition = false;
    this.eventEmitter = EventEmitter;
    this.days = 0;
    this.month = '';
    this.coinSide;
    this.scope = $scope;
    this.floatingActionButtonsService = floatingActionButtonsService;
  }

  $onInit() {
    if (!this.cardData) return;
    moment.locale('es');
    let dateToGetMonth = new Date(this.cardData.enjoymentYear,
      this.cardData.enjoymentMonth - 1);
    this.month = moment(dateToGetMonth).format('MMMM');
    this.initDays = this.cardData.enjoymentDays;
    this.days = this.cardData.enjoymentDays;
    this.daysBackup = this.days;
    this.initState = this.cardData.state;
    this.stateBackup = this.cardData.state;
    this.startWatchingDays();

    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  startWatchingDays() {
    this.scope.$watch(() => this.days, () => {
      if (isUndefinedOrNullOrEmpty(this.days)) {
        return;
      }
      if (this.isNotValidAmountOfDays()) {
        this.cardData.state = FOOD_BENEFIT_STATES.error;
      }
    });
  }

  cardIsEdited() {
    return !this.floatingActionButtonsService.isFocused && !this.daysIsFocused && this.isDayModified();
  }

  isDayModified() {
    return this.inEditMode && !this.isSendDisabled();
  }

  toNotEditMode() {
    if (this.isMobileApp) {
      this.daysIsFocused = false;
      let event = this.eventEmitter({
        isFocused: this.daysIsFocused
      });
      this.focused(event);
      this._setDefaultDaysValueWhenEmpty();
    }
  }

  toEditMode() {
    this.inEditMode = true;
    if (this.isMobileApp) {      
      this.daysIsFocused = true;
      let event = this.eventEmitter({
        isFocused: this.daysIsFocused
      });
      this.focused(event);
    }
    this.checkFirstEdition();    
  }

  setModified() {
    if(this.cardData.state ==='' || !this.isSendDisabled())
      this.cardData.state = FOOD_BENEFIT_STATES.modified;
  }

  checkFirstEdition() {
    if(this.cardData.state ==='' && this.days== 0){
      this.wasFirstEdition = true;
      this.edit();
    }
  }

  toOriginalState() {
    this.cardData.state = this.stateBackup;
  }
  
  edit() {
    this.sanitizeDayPeriods();
    this.cardData.enjoymentDays = this.days;
    this.setCardState();
    let event = this.eventEmitter(this.cardData);
    this.sendEditNotification(event);
  }

  setCardState(){
    let isEditedToOriginalData = parseInt(this.cardData.enjoymentDays) === parseInt(this.daysBackup) && !this.wasFirstEdition;
    this.setModified();
    if(isEditedToOriginalData){
      this.inEditMode = false;
      this.toOriginalState();
    } 
  }

  send() {
    this.inEditMode = false;
    this.cardData.requestErrorMsg = '';
    if (this.isNotValidAmountOfDays()) {
      this.cardData.state = FOOD_BENEFIT_STATES.error;
      return;
    }

    let event = this.eventEmitter(this.cardData);
    this.sendRequest(event);
  }

  isNotValidAmountOfDays() {
    return this.days < MIN_DAYS || isUndefinedOrNullOrEmpty(this.days)
    || this.days > this.cardData.maximumNumberDaysPerMonth;
  }

  increaseOneDay() {
    const NEXT_DAY = this.days + 1;
    if (NEXT_DAY <= this.cardData.maximumNumberDaysPerMonth) {
      this.days = this.days + 1;
    } else {
      this.cardData.state = FOOD_BENEFIT_STATES.error;
    }

    this.edit();
  }

  decreaseOneDay() {
    const PREV_DAY = this.days - 1;
    if (PREV_DAY >= MIN_DAYS) {
      this.days = this.days - 1;
    } else {
      if(!this.wasFirstEdition)
        this.cardData.state = FOOD_BENEFIT_STATES.error;
    }

    this.edit();
  }

  isRequestSended() {
    return this.requested || this.approved;
  }

  isModifiedByManager() {
    const SHOW_LABEL = false;
    return !this.inEditMode && this.approved && SHOW_LABEL;
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SEND'
      }
    ];
  }

  isSendDisabled() {
    return parseInt(this.days) === parseInt(this.initDays) && (this.initState === FOOD_BENEFIT_STATES.approved || this.initState === FOOD_BENEFIT_STATES.requested);
  }

  sanitizeDayPeriods() {    
    if(!this.isMobileApp){ 
      this._setDefaultDaysValueWhenEmpty();

      if (this.days < MIN_DAYS) this.days = MIN_DAYS;
      
      this.days = parseInt(this.days);
    } 
  }

  _setDefaultDaysValueWhenEmpty() {
    const isDaysEmpty = isNaN(this.days) || this.days === '' || !this.days;
    if(isDaysEmpty) this.days = MIN_DAYS;
  }

  getClassInDaysInput() {
    return {
      'active': this.inEditMode && !this.isSendDisabled(),
      'requested': this.isRequestSended() && !this.inEditMode,
      'not-modified': this.isMobileApp && !this.daysIsFocused && this.isSendDisabled()
    };
  }

  showRequestedIcon() {
    return this.requested && !this.daysIsFocused && this.isSendDisabled();
  }

  showApprovedIcon() {
    return this.approved && !this.daysIsFocused && this.isSendDisabled();
  }

}

export default CardRequestDaysController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestDays/cardRequestDays.controller.js